import * as Yup from "yup";
import { validateStringWordCount } from "../helpers/validationHelpers";

export const SIGN_IN_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string().required("Required field").email("Invalid email format"),
  password: Yup.string().required("Required field"),
});

export const SIGN_UP_JOB_SEEKER_VALIDATION_SCHEMA = Yup.object({
  firstName: Yup.string().required("Required field"),
  lastName: Yup.string().required("Required field"),
  email: Yup.string().required("Required field").email("Invalid email format"),
  password: Yup.string()
    .required("Required field")
    .matches(
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/,
      "8 characters or longer. Password must contain numbers, uppercase and lowercase letters."
    ),
});

export const SIGN_UP_EMPLOYER_VALIDATION_SCHEMA = Yup.object({
  company: Yup.string().required("Required field"),
  firstName: Yup.string().required("Required field"),
  lastName: Yup.string().required("Required field"),
  email: Yup.string().required("Required field").email("Invalid email format"),
  phoneNumber: Yup.string().required("Required field"),
  password: Yup.string()
    .required("Required field")
    .matches(
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/,
      "8 characters or longer. Password must contain numbers, uppercase and lowercase letters."
    ),
});

export const CHANGE_PASSWORD_VALIDATION_SCHEMA = Yup.object({
  newPassword1: Yup.string()
    .required("Required field")
    .matches(
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/,
      "8 characters or longer. Password must contain numbers, uppercase and lowercase letters."
    ),
  newPassword2: Yup.string().oneOf(
    [Yup.ref("newPassword1"), null],
    "Passwords do not match"
  ),
});

export const PASSWORD_RECOVERY_EMAIL_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string().required("Required field").email(),
});

export const SIGNIN_FORM_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string().required(),
  password: Yup.string().required(),
});

export const RESET_PASSWORD_VALIDATION_SCHEMA = Yup.object({
  newPassword1: Yup.string().required("Password is required"),
  newPassword2: Yup.string().oneOf(
    [Yup.ref("newPassword1"), null],
    "Passwords do not match"
  ),
});

export const POST_JOB_VALIDATION_SCHEMA = Yup.object({
  title: Yup.string().required("Required field"),
  // type: Yup.string().required("Required field"),
  // industry: Yup.string().required("Required field"),
  // salary: Yup.object().shape({
  //   display: Yup.string().required("Required field"),
  // }),

  // contactName: Yup.string().required("Required field"),
  phoneNumber: Yup.number().typeError("Invalid phone number"),
  contactEmail: Yup.string().email("Invalid email format"),
  contactWebsiteUrl: Yup.object().shape({
    url: Yup.string().matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Invalid URL"
    ),
  }),
});

export const COMPANY_LOGO_FEATURE_VALIDATION_SCHEMA = Yup.object({
  featuredCompanyLogoURL: Yup.string().required("Required field"),
});

export const ADMIN_REVIEW_LOCATION_VALIDATION_SCHEMA = Yup.object({
  locality: Yup.string().required("Required field"),
  areaLevelOne: Yup.string().required("Required field"),
  countryCode: Yup.string().required("Required field"),
  country: Yup.string().required("Required field"),
});

export const ADMIN_REVIEW_LISTED_LOCATION_VALIDATION_SCHEMA = Yup.object({
  address: Yup.string().required("Required field"),
  city: Yup.string().required("Required field"),
  country: Yup.string().required("Required field"),
  countryCode: Yup.string().required("Required field"),
});

export const BILLING_ADDRESS_VALIDATION_SCHEMA = Yup.object({
  lineOne: Yup.string().required("Required field"),
  postcode: Yup.string().required("Required field"),
  city: Yup.string().required("Required field"),
});

export const TAX_NUMBER_VALIDATION_SCHEMA = Yup.object({
  taxNumber: Yup.string().required("Required field"),
});

export const COMPANY_PROFILE_FORM_VALIDATION_SCHEMA = Yup.object({
  name: Yup.string().required("Required field"),

  // companyLogoPhotoURL: Yup.string().required("Company logo is required"),

  type: Yup.string().required("Required field"),
  industry: Yup.string().required("Required field"),

  // location: Yup.object().shape({
  //   address: Yup.string().required(""),
  // }),

  employeeSize: Yup.string(),
  yearFounded: Yup.string(),

  websiteLink: Yup.string()
    .required("Required field")
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Invalid URL"
    ),

  linkedInLink: Yup.string().matches(
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    "Invalid URL"
  ),
  twitterLink: Yup.string().matches(
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    "Invalid URL"
  ),
  facebookLink: Yup.string().matches(
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    "Invalid URL"
  ),
  instagramLink: Yup.string().matches(
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    "Invalid URL"
  ),

  contactEmail: Yup.string().email("Invalid email format"),
  phoneNumber: Yup.number().typeError("Invalid phone number"),
});

export const CANDIDATE_PROFILE_FORM_VALIDATION_SCHEMA = Yup.object({
  name: Yup.string().required("Required field"),
  email: Yup.string().required("Required field").email("Invalid email format"),
  bio: Yup.string().test("bio-word-count", "Minimum 20 words", (value) =>
    validateStringWordCount(value, 20)
  ),

  cv: Yup.object().shape({
    // url: Yup.string().required("Required field"),
    // filename: Yup.string().required("Required field"),
    url: Yup.string(),
    filename: Yup.string(),
  }),

  linkedInURL: Yup.string().matches(
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
    "Invalid URL"
  ),

  roleLevel: Yup.array()
    .min(1, "Role level Required")
    .required("Required field"),

  industries: Yup.array(),

  status: Yup.string().required("Required field"),

  isAvailableForInterviews: Yup.bool().required("Required"),
  isVisibleToEmployers: Yup.bool().required("Required"),
});

export const JOB_ALERTS_CUSTOM_PREFERENCES_VALIDATION_SCHEMA =
  Yup.object().shape(
    {
      locations: Yup.array().min(1, "Add Location(s)"),
      industries: Yup.array().when("jobKeywords", {
        is: (value) => {
          return !!value && value.length === 0;
        },
        then: Yup.array().min(1, "Add Industry and/or Keywords"),
        otherwise: Yup.array().notRequired(),
      }),
      jobKeywords: Yup.array().when("industries", {
        is: (value) => {
          return !!value && value.length === 0;
        },
        then: Yup.array().min(1, "Add Keywords and/or Industry"),
        otherwise: Yup.array().notRequired(),
      }),
    },
    [["industries", "jobKeywords"]]
  );

export const JOB_ALERTS_PHARMA_PREFERENCES_VALIDATION_SCHEMA =
  Yup.object().shape({
    locations: Yup.array().min(1, "Add Location(s)"),
  });
